import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { log } from '../../services/utils';

import styles from './table.module.css';

const TableFilters = ( { headerGroups } ) => {
	const filtersDisabled = () => headerGroups.every( ( { headers } ) => headers.disableFilters );

	return (
		<>
			{ log( '- tableFilters' ) }
			{ filtersDisabled()
				? null
				: <div className={ styles.tableFilters }>
					{ headerGroups.map( ( headerGroup, i ) => (
						<div
							{ ...headerGroup.getHeaderGroupProps() }
							className={ styles.tableRow }
							key={ i }
						>
							{ headerGroup.headers.map( ( column, i ) => (
								<div
									{ ...column.getHeaderProps() }
									key={ i }
									className={ styles.tableCell }
								>
									{ column.canFilter
										? column.render( 'Filter' )
										: null
									}
								</div>
							) )
							}
						</div>
					) ) }
				</div>
			}
		</>
	);
};

TableFilters.propTypes = { headerGroups: PropTypes.array.isRequired };

export default memo( TableFilters );
